import Image from 'app/Components/Shared/Image/image';
import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {setTabItems, activateTab, setPopUp, resetBlock, reportAnalytics} from './TabsContainerSlice';
import noImage from './images/no-image.svg';
import Config from '../../../Config';
import {Col, Row, Container} from 'reactstrap';
import {isMobile} from 'react-device-detect';
import PopUp from '../../../Components/Shared/Popup/PopUp';
import gaParams from '../../../utilities/analytics/constants';

const TabsContainer = (props) => {
  const search = 'עמוד תוצאות חיפוש';
  const lobby = 'עמוד לובי';

  useEffect(() => {
    window.addEventListener('scroll', trackScrolling);
    const tabItems = props.data.tabsContentArea?.expandedValue?.map((item, i) => ({
      active: false,
      id: i,
      tabName: item.tabName.value,
      mobileTabName: item.mobileTabName.value,
      icon: item.icon.value ? Config.epiBaseUrl + item.icon.value.url : noImage,
      mobileIcon: item.mobileIcon.value ? Config.epiBaseUrl + item.mobileIcon.value.url : noImage,
      contentTitle: item.contentTitle.value,
      subContentTitle: item.subContentTitle.value != null ? item.subContentTitle.value : null,
      listItems: item.listItemsContentArea?.expandedValue != null ? item.listItemsContentArea?.expandedValue : null,
    }));

    props.setTabItems({items: tabItems});

    return () => {
      window.removeEventListener('scroll', trackScrolling);
      props.resetBlock();
    };
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', trackScrolling);

    return () => {
      window.removeEventListener('scroll', trackScrolling);
    };
  }, [props.activeLobbyTab, props.abroadPackagesList]);

  function trackScrolling() {
    const wrappedElement = document.getElementById('tabs-container');
    if (isBottom(wrappedElement)) {
      if (props.activeLobbyTab == 'businessAccount') {
        if (props.otpData.validatedCostumerData?.isSeparatedSale) {
          props.reportAnalytics({
            eventCategory: gaParams.SEPARATED_MOMENTBEFOREFLIGHT_SHOW.category,
            eventAction: gaParams.SEPARATED_MOMENTBEFOREFLIGHT_SHOW.eventType,
            eventLabel: props.abroadPackagesList ? search : lobby,
          });
        } else {
          props.reportAnalytics({
            eventCategory: 'hul_sale_business',
            eventAction: 'visibility_19',
            eventLabel: props.abroadPackagesList ? search : lobby,
          });
        }
      } else {
        if(!props.businessIndividual){
          props.reportAnalytics({
            eventCategory: 'hul_sale_private',
            eventAction: 'visibility_11',
            eventLabel: props.abroadPackagesList ? search : lobby,
          });
        }
       
      }

      window.removeEventListener('scroll', trackScrolling);
    }
  }

  function isBottom(el) {
    return el.getBoundingClientRect().bottom <= window.innerHeight;
  }

  const selectTab = (tabId, tabName) => {
    props.activateTab({id: tabId, items: props.tabItems, isMobile: isMobile});
    props.reportAnalytics({
      eventCategory: 'hul_sale_business',
      eventAction: 'click_19',
      eventLabel: props.abroadPackagesList ? search : lobby + '/' + tabName,
    });
  };

  const closePopUp = () => {
    props.setPopUp({status: false});
  };

  return (
    <div style={{textAlign: 'center'}}>
      {props.template ? (
        <TabContainerNoContent context={props.context} data={props.data} />
      ) : (
        <div id='tabs-container' className='tabs-container'>
          <h2
            onClick={() => {
              if (props.otpData.validatedCostumerData?.isSeparatedSale) {
                props.reportAnalytics({
                  eventCategory: gaParams.SEPARATED_IMPORTANTTOKNOWBEFOREFLIGHT.category,
                  eventAction: gaParams.SEPARATED_IMPORTANTTOKNOWBEFOREFLIGHT.eventType,
                  eventLabel: props.abroadPackagesList ? search : lobby,
                });
              }
            }}
            dangerouslySetInnerHTML={{__html: isMobile ? props.data.mobileTitle.value : props.data.title.value}}></h2>

          <h3>{isMobile ? props.data.mobileSubTitle.value : props.data.subTitle.value}</h3>

          <Row style={{textAlign: 'center', display: 'inline'}}>
            <Col>
              <div className='tab-row'>
                <Row>
                  {props.tabItems?.map((item, i) => (
                    <Col key={i} style={{paddingRight: '0px', paddingLeft: '0px', marginBottom: '25px'}}>
                      <div
                        onClick={(e) => selectTab(item.id, item.tabName)}
                        className={item.active && !isMobile ? 'tabItem selected' : 'tabItem'}>
                        <div className='tabItem__center-div'>
                          <div className='image'>
                            <Image style={{maxWidth: '70px', maxHeight: '73px'}} src={item.icon} />
                          </div>
                          <span className='title'>{item.tabName}</span>
                        </div>

                        <div className={item.active && !isMobile ? 'tabItem__button__selected' : 'tabItem__button'}>
                          <div className={item.active && !isMobile ? 'circle-border-selected' : 'circle-border'}>
                            {item.active && !isMobile ? <span>&#x2715;</span> : <span>&#43;</span>}
                          </div>
                        </div>
                      </div>
                    </Col>
                  ))}
                </Row>
              </div>
            </Col>
          </Row>

          <PopUp showPopUp={props.showPopUp} onClose={() => closePopUp()} className='popup-tab-container'>
            <div id='mobileContent'>
              <div className='listItem-title'>{props.contentTitle}</div>
              <div className='listItem-sub-title'>{props.contentSubTitle}</div>
              <br />

              {props.listItems?.map((item, i) => (
                <Row key={i} style={{marginTop: '25px'}}>
                  <Col xs='12' sm='12' md='12'>
                    {item.icon.value ? (
                      <div className='rounded-rectangle'>
                        <Image style={{maxWidth: '100%', maxHeight: '100%', margin: 'auto'}}
                          src={item.icon.value ? Config.epiBaseUrl + item.icon.value.url : noImage} />
                      </div>
                    ) : (
                      ''
                    )}
                    <div className='item-title'>{item.title.value}</div>
                    <div dangerouslySetInnerHTML={{__html: item.textEditor.value}} className='listItem-content'></div>
                  </Col>
                </Row>
              ))}
            </div>
          </PopUp>

          {props.isShowContent ? (
            <div style={{textAlign: 'center'}}>
              <div id='content' className={isMobile ? 'hide-content' : 'content'}>
                <div className='listItem-title'>{props.contentTitle}</div>
                <div className='listItem-sub-title'>{props.contentSubTitle}</div>
                <br />

                {props.listItems?.map((item, i) => (
                  <Row key={i} style={{marginTop: '30px', minHeight: '85px'}}>
                    <Col xs='3' sm='2' md='2'>
                      {item.icon.value ? (
                        <div className='item-img'>
                          <Image src={item.icon.value ? Config.epiBaseUrl + item.icon.value.url : noImage} />
                        </div>
                      ) : (
                        ''
                      )}
                    </Col>
                    <Col xs='9' sm='10' md='10'>
                      <div className='item-title'>{item.title.value}</div>
                      <div dangerouslySetInnerHTML={{__html: item.textEditor.value}} className='listItem-content'></div>
                    </Col>
                  </Row>
                ))}
              </div>
            </div>
          ) : (
            ''
          )}
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    tabItems: state.tabsContainer.tabItems,
    contentTitle: state.tabsContainer.contentTitle,
    contentSubTitle: state.tabsContainer.contentSubTitle,
    listItems: state.tabsContainer.listItems,
    isMobileView: state.tabsContainer.isMobile,
    showPopUp: state.tabsContainer.isShowPopUp,
    isShowContent: state.tabsContainer.isShowContent,
    activeLobbyTab: state.cellcomAbroad.activeLobbyTab,
    abroadPackagesList: state.cellcomAbroad.abroadPackagesList,
    businessIndividual: state.cellcomAbroad.epiStyleInitializationData.businessIndividualLobby,
    otpData: state.cellcomAbroad.otpData,
  };
};

const mapDispatchToProps = {
  setTabItems,
  activateTab,
  setPopUp,
  resetBlock,
  reportAnalytics,
};

export default connect(mapStateToProps, mapDispatchToProps)(TabsContainer);
